import React from 'react'
import { Spinner } from '../Spinner'
import { hasWindow } from '@ztechapps/common.utils'

export type ClientOnlyProps = {
  component: () => Promise<any>
} & Record<string, any>

export const ClientOnly = ({ component, ...rest }: ClientOnlyProps) => {
  const [Component, setComponent] = React.useState<React.ComponentType<any> | null>(null)

  const withWindows = hasWindow()

  React.useEffect(() => {
    if (!withWindows) return

    component().then((mod) => {
      // Handle double-wrapped modules from Vite's CommonJS interop
      // Structure can be: { default: Component } or { default: { default: Component } }
      let Comp = mod.default || mod
      if (Comp && typeof Comp === 'object' && 'default' in Comp) {
        Comp = Comp.default
      }
      setComponent(() => Comp)
    })
  }, [withWindows, component])

  if (!Component) return <Spinner />

  return <Component {...rest} />
}
